var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var IconFont = function (_a) {
    var type = _a.type, style = _a.style, other = _a.other, onClick = _a.onClick, className = _a.className;
    return (React.createElement("svg", __assign({ className: "icon " + className, "aria-hidden": "true", style: __assign({ verticalAlign: 'middle' }, style), dangerouslySetInnerHTML: {
            __html: "<use xlink:href=\"#" + type + "\"></use>",
        }, onClick: onClick }, other)));
};
// const IconFont = createFromIconfontCN({
//     scriptUrl: '//at.alicdn.com/t/font_1717591_5fs7ttlpnm6.js', // './icon/iconfont.js',
// });
export default IconFont;
export var IconSearch = React.createElement(IconFont, { type: "iconapp_ic_search" });
export var IconMale = React.createElement(IconFont, { type: "iconapp_sex_male" });
export var IconFeMale = React.createElement(IconFont, { type: "iconapp_sex_female" });
export var IconClose = React.createElement(IconFont, { type: "iconwin_Close" });
export var IconClose_2 = React.createElement(IconFont, { type: "iconapp_btn_more_cancel" });
export var IconCamera = React.createElement(IconFont, { type: "iconbtn_camera_editor" });
export var IconOrg = React.createElement(IconFont, { type: "iconapp_btn_cha" });
export var IconAdd = React.createElement(IconFont, { type: "iconbtn_add" });
export var IconChat = React.createElement(IconFont, { type: "iconic_chat" });
export var IconAddUser = React.createElement(IconFont, { type: "iconapp_btn_joymeeting_group" });
export var IconJoyspace = React.createElement(IconFont, { type: "iconapp_ic_bardoc" });
export var IconCalendar = React.createElement(IconFont, { type: "iconic_day" });
export var IconThirdApp = React.createElement(IconFont, { type: "iconapp_tabbar_application" });
export var IconEBook = React.createElement(IconFont, { type: "iconapp_btn_addressbook" });
export var IconSetup = React.createElement(IconFont, { type: "iconapp_btn_Setup" });
export var IconArrowRight = React.createElement(IconFont, { type: "iconapp_ic_arrow_right" });
export var IconReturnGroup = React.createElement(IconFont, { type: "iconapp_btn_nb_return" });
export var IconDel = React.createElement(IconFont, { type: "iconlog_del", style: { color: '#BFC1C4' } });
export var IconMore = React.createElement(IconFont, { type: "iconwin_more" });
export var IconGroup = React.createElement(IconFont, { type: "iconapp_btn_peoplegroup" });
export var IconMeeting = React.createElement(IconFont, { type: "iconapp_ic_join_meeting" });
export var IconJoinMeeting = React.createElement(IconFont, { type: "iconapp_ic_join_meeting" });
export var IconAppointMeeting = React.createElement(IconFont, { type: "iconbtn_video_editor" });
export var IconEdit = React.createElement(IconFont, { type: "iconapp_btn_edit" });
export var IconFailure = React.createElement(IconFont, { type: "iconic_failure" });
export var IconExit = React.createElement(IconFont, { type: "iconbtn_exit" });
export var IconJSclose = React.createElement(IconFont, { type: "iconjs_ic_closed" });
export var IconWinLeft = React.createElement(IconFont, { type: "iconwin_left" });
export var IconWinRight = React.createElement(IconFont, { type: "iconwin_right" });
export var IconStars = React.createElement(IconFont, { type: "iconic_pc_stars" });
export var IconCircleClose = React.createElement(IconFont, { type: "iconjs_ic_error" });
export var IconCloseEye = React.createElement(IconFont, { type: "iconzw_web_eye_closed" });
export var IconTitleRight = React.createElement(IconFont, { type: "iconic_joyday_title_dropdown" });
export var IconMultimedia = React.createElement(IconFont, { type: "iconapp_btn_joymeeting_video" }); // TODO: 临时使用该图标
export var IconShare = React.createElement(IconFont, { type: "iconapp_btn_peopleshare" });
export var IconWork = React.createElement(IconFont, { type: "iconbacklog" });
export var IconRefresh = React.createElement(IconFont, { type: "iconbtn_reduction" });
export var IconMail = React.createElement(IconFont, { type: "iconapp_btn_pc_mail" });
export var IconRdit = React.createElement(IconFont, { type: "iconrdit" });
export var IconSet = React.createElement(IconFont, { type: "iconicon_Set" });
export var IconManager = React.createElement(IconFont, { type: "iconiconbtn_manager" });
export var IconCopyBtn = React.createElement(IconFont, { type: "iconweb_btn_copy" });
export var IconMute = React.createElement(IconFont, { type: "iconmute" });
export var IconDocHome = React.createElement(IconFont, { type: "iconapp_ic_dochome" });
export var IconMyDoc = React.createElement(IconFont, { type: "iconapp_ic_mydoc" });
export var IconMobilePhone = React.createElement(IconFont, { type: "iconic_mobilephone" });
// 收藏
export var IconKeep = React.createElement(IconFont, { type: "iconic_yipingfen" });
export var IconCancelKeep = React.createElement(IconFont, { type: "iconic_pingfen" });
// 圆加号
export var IconAddApp = React.createElement(IconFont, { type: "iconapp_btn_add" });
// 圆取消
// 搜索
// export const IconSearch = <IconFont type="iconic_search" />;
export var IconRemind3 = React.createElement(IconFont, { type: "iconzw_app_remind3" }); // 催办小铃铛图标
// export const IconlogDown = <IconFont type="iconlog_down" />;
export var IconDefualtOrg = (React.createElement("div", { style: {
        color: '#fff',
        backgroundColor: '#306fdc',
        borderRadius: 8,
        height: 36,
        width: 36,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    } },
    React.createElement(IconFont, { type: "iconapp_btn_cha" })));
export var IconRight = React.createElement(IconFont, { type: "iconapp_ic_arrow_right" });
export var IconArrowLeft = React.createElement(IconFont, { type: "iconwin_left" });
export var IconJoyMeetingGroup = React.createElement(IconFont, { type: "iconapp_btn_joymeeting_group" });
export var IconTopUp = React.createElement(IconFont, { type: "iconapp_btn_top_up" });
export var IconSwitch = React.createElement(IconFont, { type: "iconlog_switch" });
export var IconApplicationShop = React.createElement(IconFont, { type: "iconapp_application_shop" });
export var getIconFromString = function (type) { return React.createElement(IconFont, { type: type }); };
export var IconicPcDongaoAdd = React.createElement(IconFont, { type: "iconic_pc_dongao_add" });
export var IconbtnTopUp = React.createElement(IconFont, { type: "iconbtn_top_up" });
export var IconbtnTopDown = React.createElement(IconFont, { type: "iconbtn_top_down" });
//# sourceMappingURL=IconFont.js.map